export const CATSAS_SPECIALS_TOP_ESPOT = 'CATSAS_SPECIALS_TOP_ESPOT';
export const ESPOT_TYPES = {
  CAROUSEL: 'carousel_promotion',
  STATIC: 'static_promotion'
};
export const SALESFORCE_CHAT_CLASSNAME = '.embeddedServiceHelpButton';
export const TRANS_TIME = 7000;
